import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  View,
  TouchableOpacity,
  ActivityIndicator,
  Dimensions,
} from 'react-native';
import {
  Button, Text,
  Icon,
  Input,
} from 'react-native-elements';
import { FlatGrid } from 'react-native-super-grid';
import { withApollo } from '@apollo/client/react/hoc';
import { compareVersions } from 'compare-versions';
// import { ifIphoneX } from 'react-native-iphone-x-helper';
import { TagCloud } from 'react-tagcloud/rn';

import { language } from '../../localization';
import AORTypes from '../../types';
import styles from '../../styles';
import { translate } from '../../locales/i18n';
import tagsEn from '../../data/locale/tags/en.json';
import tagsRu from '../../data/locale/tags/ru.json';
import AppBadge from '../../components/apps/AppBadge';
import GetAppsByPrefix from '../../q/GetAppsByPrefix';
import SuperFlatFading from '../../components/effects/SuperFlatFading';
import version from '../../version.json';
import App from '../../modules/data/App';
// import { throttle } from '../../modules/Utils';
// import { fixGoogleMapsWebStyles } from '../../modules/Utils';
// import ImagePlus from '../../assets/images/plus.svg';
// import ImageMinus from '../../assets/images/minus.svg';

class Home extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Home';

    this.loadTags = this.loadTags.bind(this);
    this.getLanguages = this.getLanguages.bind(this);

    const { searchName } = this.props;

    this.state = {
      appsByTags: {},
      selectedItem: '',
      initialLoad: true,
      search: searchName,
    };
  }

  componentDidMount() {
    console.log('Home.componentDidMount()');

    const { searchName } = this.props;

    this.loadTags(searchName ? { tag1: searchName } : undefined)
      .then((stateDelta) => {
        this.setState(stateDelta);
        console.log('refreshing');
      });
  }

  componentDidUpdate(prevProps) {
    console.log('Home.componentDidUpdate()');

    const { searchName } = this.props;

    if (searchName !== prevProps.searchName) {
      this.state.search = searchName;
      this.state.initialLoad = true;

      this.loadTags(searchName ? { tag1: searchName } : undefined)
        .then((stateDelta) => {
          this.setState(stateDelta);
          console.log('refreshing');
        });
    }
  }

  getLanguages() {
    const { userData } = this.props;

    const lang = language();
    let langs = ['en'];
    if (lang) {
      langs[0] = lang;
    }
    if (userData) {
      langs = JSON.parse(userData.langs);
    }

    return langs;
  }

  async loadTags(inputNewTags) {
    console.log('loadTags()');
    console.log(inputNewTags);
    console.trace();

    const { tag1, tag2, tag3 } = this.state;
    const { appsByTags } = this.state;
    const {
      client,
      getAnalyticsService,
    } = this.props;

    const langs = this.getLanguages();

    // console.log('loadTags(): called');
    // console.log(newTags);

    let newTags = inputNewTags;

    let tagCount = 0;
    if (newTags === undefined
      || (newTags.tag1 === undefined
        && newTags.tag2 === undefined
        && newTags.tag3 === undefined)) {
      const lang = language() || 'en';
      if (lang === 'ru') {
        newTags = {
          tag1: 'Реклама',
          tag2: 'CAD',
          tag3: 'ИИ',
        };
      } else {
        newTags = {
          tag1: 'Ads',
          tag2: 'CAD',
          tag3: 'AI',
        };
      }
    } else if (newTags.tag2) {
      tagCount = 2;
    } else if (newTags.tag3) {
      tagCount = 3;
    } else {
      tagCount = 1;
    }

    if ((tag1 === newTags.tag1
      && tag2 === newTags.tag2
      && tag3 === newTags.tag3)) {
      console.log('loadTags(): quitting as there was no change');
      return {};
    }

    console.log('tags before');
    console.log(tag1, tag2, tag3);

    console.log('tags after');
    console.log(newTags.tag1 || 'undefined', newTags.tag2 || 'undefined', newTags.tag3 || 'undefined');

    const prefixes = [];
    if (newTags.tag1) {
      prefixes.push(newTags.tag1);
      if (newTags.tag2) {
        prefixes.push(newTags.tag2);
        prefixes.push(`${newTags.tag1}%${newTags.tag2}`);
        prefixes.push(`${newTags.tag2}%${newTags.tag1}`);
        if (newTags.tag3) {
          prefixes.push(newTags.tag3);
          prefixes.push(`${newTags.tag1}%${newTags.tag3}`);
          prefixes.push(`${newTags.tag3}%${newTags.tag1}`);
          prefixes.push(`${newTags.tag2}%${newTags.tag3}`);
          prefixes.push(`${newTags.tag3}%${newTags.tag2}`);
          prefixes.push(`${newTags.tag1}%${newTags.tag2}%${newTags.tag3}`);
          prefixes.push(`${newTags.tag1}%${newTags.tag3}%${newTags.tag2}`);
          prefixes.push(`${newTags.tag2}%${newTags.tag1}%${newTags.tag3}`);
          prefixes.push(`${newTags.tag2}%${newTags.tag3}%${newTags.tag1}`);
          prefixes.push(`${newTags.tag3}%${newTags.tag1}%${newTags.tag2}`);
          prefixes.push(`${newTags.tag3}%${newTags.tag2}%${newTags.tag1}`);
        }
      }
    }

    const langPrefixes = [];
    prefixes.forEach((prefix) => {
      langs.forEach((lang) => {
        langPrefixes.push(`${lang}-${prefix}`);
      });
    });
    console.log('langPrefixes');
    console.log(langPrefixes);

    getAnalyticsService().report.event('query', 'home', 'tagCount', tagCount);

    // Prepare a place to store the new set of apps
    const newAppsByTags = {};

    // Copy apps-per-prefix if they are already known from before
    if (appsByTags !== null) {
      Object.keys(appsByTags).forEach((oldPrefix) => {
        const keep = (langPrefixes.indexOf(oldPrefix) !== -1);

        if (keep) {
          // console.log(`keeping the prefix ${oldPrefix}`);
          newAppsByTags[oldPrefix] = appsByTags[oldPrefix];
        } else {
          // console.log(`deleting the prefix ${oldPrefix}`);
        }
      });
    }

    // console.log(client);
    const promises = [];
    langPrefixes.forEach((langPrefix) => {
      if (appsByTags !== null) {
        if (appsByTags[langPrefix] !== undefined) {
          // We have this prefix retained already
          return;
        }
      }

      const prefix = langPrefix.substring(3);
      const lang = langPrefix.substring(0, 2);

      console.log(`adding prefix: ${prefix}, lang: ${lang}`);

      getAnalyticsService().report.event('home', 'list', 'langPrefix', langPrefix);
      // getAnalyticsService().report.event('home', 'list', 'langs', JSON.stringify(langs));

      const prefixLen = prefix.split('%').length;
      // const prefixIters = prefixLen === 1 ? 5 : (prefixLen === 2 ? 10 : 6);
      let prefixIters = 5;
      if (prefixLen === 2) {
        prefixIters = 8;
      } else if (prefixLen === 3) {
        prefixIters = 6;
      }
      // const prefixIters = 1;
      newAppsByTags[langPrefix] = [];
      // const langPrefixComponents = {};
      // function langPrefixComponentHash(l, p, ln, i) {
      //   return `${l}-${p}-${ln}-${i}`;
      // }
      for (let i = 1; i <= prefixIters; i += 1) {
        promises.push(new Promise((resolve, reject) => {
          const observable = client.watchQuery({
            fetchPolicy: 'cache-and-network',
            // fetchPolicy: 'network-only',
            fetchResults: true,
            query: GetAppsByPrefix,
            variables: {
              lang,
              prefix,
              len: prefixLen,
              iter: i,
            },
          });

          // console.log('observable');
          // console.log(observable);

          observable.subscribe({
            next(result) {
              // console.log('observed a result');
              // console.log(result);
              if (!result) {
                return;
              }

              // if (result.loading === true) {
              //   // if we 'return' now, we'll never prompt for an update
              //   resolve(null);
              //   // return;
              // }

              if (result
                && result.data
                && result.data.listAppsByPrefix
                && result.data.listAppsByPrefix.items
                && result.data.listAppsByPrefix.items.length > 0) {
                console.log('found items');
                console.log(result.data.listAppsByPrefix.items.length);
                console.log(result.data.listAppsByPrefix.items);
                const addApps = result.data.listAppsByPrefix.items.map((item) => App.createFromData(item));
                // langPrefixComponents[langPrefixComponentHash(lang, prefix, prefixLen, i)] = addApps;
                // newAppsByTags[langPrefix].push(...Object.values(langPrefixComponents).flat());
                newAppsByTags[langPrefix] = addApps;
                // newAppsByTags[langPrefix].push(...addApps);
                // resolve(null);
                // return;
                // } else {
                //   // TODO(clairbee): refact Home.js to subscribe to new data changes and to reflect them in the UI
                //   resolve([]);
              }

              if (result.loading !== true) {
                // Nothing to wait for
                resolve(null);
              }
            },
            complete() {
              // console.log('observation is complete');
              resolve(null);
            },
            error(err) {
              console.log('watchQuery failed');
              console.log(err);
              reject(err);
            },
          });
        }));
      }
    });

    console.log('prefixes to be used');
    console.log(Object.keys(appsByTags));

    await Promise.all(promises);

    console.log('loadTags(): done');
    console.log(newAppsByTags);

    return {
      appsByTags: newAppsByTags,
      initialLoad: false,
    };
  }

  render() {
    const {
      direction, history, user, config,
      // userData,
      searchInProgress,
      searchNotFound,
      searchName,
      // searchPosition,
      getAnalyticsService,
    } = this.props;
    const {
      appsByTags, selectedItem, initialLoad,
      search,
    } = this.state;

    console.log('Home.render(): checking version');
    if (config && config.verListApps && compareVersions(version, config.verListApps) < 0) {
      console.log('current version');
      console.log(version);
      console.log('required version');
      console.log(config.verListApps);

      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View
            style={{
              backgroundColor: 'white',
              borderColor: styles.primaryColor,
              borderWidth: 1,
              padding: 20,
            }}
          >
            <Text>
              {translate('home_update')}
            </Text>
          </View>
        </View>
      );
    }

    console.log('Home.render(): ok to render');

    console.log('appsByTags in render');
    console.log(appsByTags);
    const items = [];

    Object.keys(appsByTags).forEach((prefix) => {
      console.log(`about to display prefix ${prefix}`);
      console.log('items');
      console.log(appsByTags[prefix]);
      appsByTags[prefix].forEach((item) => {
        item.postProcess();

        if (item.data.uuid === selectedItem) {
          items.unshift(item);
        } else {
          items.push(item);
        }
      });
    });

    const langs = this.getLanguages();

    const mapRadius = 20;
    if (Platform.OS === 'web') {
      // fixGoogleMapsWebStyles(direction);
    }

    const displayTags = {
      en: tagsEn,
      ru: tagsRu,
    };

    const data = [];
    let displayTagsByLang = [];
    langs.forEach((lang) => {
      displayTagsByLang.push(...(displayTags[lang] || []));
    });

    // if the number of tags is too high, take a random sample
    if (displayTagsByLang.length > 30) {
      // TODO(clairbee): instead of random, take the tags that are most popular
      displayTagsByLang = displayTagsByLang.sort(() => Math.random() - 0.5).slice(0, 30);
    }

    // if there are no tags, use the English tags
    if (displayTagsByLang.length === 0) {
      displayTagsByLang = displayTags.en;
    }

    const extraSize = Dimensions.get('window').width / 150;
    const minSize = 9 + extraSize;
    const maxSize = minSize + 12;

    displayTagsByLang.forEach((t) => {
      data.push({ value: t, count: Math.random() * 15 + 15 });
    });

    return (
      <View
        style={{
          flex: 1,
          flexDirection: direction,
        }}
        onLayout={this.onLayout}
        behavior="padding"
      >
        <View style={{ flex: 1, backgroundColor: '#f0f0f0' }}>
          {/* <View
            style={styles.map(direction).controlsTopRow}
          >
            <View style={styles.map(direction).controlContainer}>
              <Text
                style={styles.map(direction).mapTypeControl}
                onPress={() => {
                  const newMapType = mapType === mapTypeSatellite ? mapTypeMap : mapTypeSatellite;
                  onViewportChange({ mapType: newMapType });
                  this.setState({ mapType: newMapType });
                }}
              >
                {mapType === mapTypeSatellite ? translate('map_satellite') : translate('map_map')}
              </Text>
            </View>
          </View> */}
          <Input
            containerStyle={{
              width: '80%',
              maxWidth: 400,
              position: 'absolute',
              top: 21,
              alignSelf: 'center',
              flexDirection: 'row',
              justifyContent: 'center',
              margin: 0,
              padding: 0,
            }}
            inputContainerStyle={{
              flex: 1,
              marginHorizontal: 8,
              paddingHorizontal: 10,
              backgroundColor: 'white',
              borderRadius: 16,
              shadowOffset: {
                width: 1,
                height: 1,
              },
              shadowColor: '#757575',
              shadowRadius: 20,
              shadowOpacity: 0.25,
              overflow: 'hidden',
            }}
            inputStyle={{
            }}
            rightIconContainerStyle={{
              paddingLeft: 6,
            }}
            // placeholder={translate('error_not_yet')}
            // disabled
            placeholder={translate('home_search_placeholder')}
            rightIcon={(
              <Icon
                name="search"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
                onPress={() => {
                  getAnalyticsService().report.event('search', 'home', search);
                  // getAnalyticsService().report.event('search', 'home', 'search_button', search);
                  history.push(`/ai-agents/${search}`);
                }}
              />
            )}
            autoCapitalize="none"
            value={search}
            onChangeText={(value) => this.setState({ search: value })}
            onSubmitEditing={() => {
              getAnalyticsService().report.event('search', 'home', search);
              // getAnalyticsService().report.event('search', 'home', 'search_submit', search);
              history.push(`/ai-agents/${search}`);
            }}
            // autoFocus should be used on web, but only on desktop
            // autoFocus={Platform.OS === 'web'}
            importantForAutofill="noExcludeDescendants"
            autoCompleteType="off"
            keyboardType="web-search"
          />
          {searchInProgress && (
            <View
              style={{
                position: 'absolute',
                top: 0,
                alignSelf: 'center',
                flexDirection: 'row',
                justifyContent: 'center',
                marginTop: 130,
              }}
            >
              <View
                style={{
                  flex: 1,
                  marginHorizontal: 20,
                  padding: 10,
                  backgroundColor: 'white',
                  borderRadius: 20,
                  shadowOffset: {
                    width: 1,
                    height: 1,
                  },
                  shadowColor: '#757575',
                  shadowRadius: 20,
                  shadowOpacity: 0.25,
                  overflow: 'hidden',
                }}
              >
                <Text
                  style={{
                    textAlign: 'center',
                  }}
                >
                  {searchNotFound ? translate('home_search_not_found') : translate('home_search_in_progress')}
                </Text>
              </View>
            </View>
          )}
          {/* {Platform.OS === 'web' && (
              <View
                style={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  width: 30,
                  flexDirection: 'column',
                  margin: 18,
                  borderRadius: 16,
                  backgroundColor: 'white',
                }}
              >
                <TouchableOpacity
                  style={{
                    width: 16,
                    height: 16,
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 7,
                    marginVertical: 10,
                  }}
                  onPress={() => {
                    console.log('this.googleMap');
                    console.log(this.googleMap);
                    if (this.googleMap && this.googleMap.panToBounds) {
                      console.log('using this.googleMap');

                      const bounds = {
                        south: viewport.latitude - viewport.latitudeDelta / 4,
                        north: viewport.latitude + viewport.latitudeDelta / 4,
                        west: viewport.longitude - viewport.longitudeDelta / 4,
                        east: viewport.longitude + viewport.longitudeDelta / 4,
                      };

                      this.googleMap.panToBounds(bounds);

                      // const zoom = this.googleMap.getZoom() + 1;
                      // console.log('zoom');
                      // console.log(zoom);
                      // viewport.zoom = zoom;
                      // // this.googleMap.setOptions({ zoom });
                      // // this.googleMap.props.defaultZoom = zoom;
                      // // this.googleMap.props.options.zoom = zoom;
                      // this.forceUpdate();
                    } else if (this.mapView && this.mapView.fitToCoordinates) {
                      console.log('not supported for mobile');
                    }
                  }}
                >
                  <ImagePlus />
                </TouchableOpacity>
                <View
                  style={{
                    width: 30,
                    borderBottomWidth: 1,
                    borderBottomColor: '#e3e3e3',
                  }}
                />
                <View
                  style={{
                    width: 16,
                    height: 16,
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: 7,
                    marginVertical: 10,
                  }}
                >
                  <ImageMinus />
                </View>
              </View>
            )} */}
          <View
            style={{
              // position: 'absolute',
              // top: 88,
              // left: 0,
              // right: 0,
              bottom: mapRadius,
              // borderWidth: 1,
              // borderColor: 'red',
              flex: 1,
              alignItems: 'center',
              justifyContent: 'center',
              alignSelf: 'center',
              marginTop: 88,
              marginRight: direction === 'column' ? 0 : mapRadius,
              // marginBottom: direction === 'column' ? mapRadius : 0,
              padding: 10,
            }}
          >
            <TagCloud
              style={{
                // flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
              }}
              colorOptions={{ luminosity: 'dark', hue: styles.primaryColor }}
              // colorOptions={{ luminosity: 'dark', hue: 'blue' }}
              // disableRandomColor
              minSize={minSize}
              maxSize={maxSize}
              tags={data}
              onPress={(tag) => {
                console.log(`'${tag.value}' was selected!`);
                history.push(`/ai-agents/${tag.value}`);
              }}
            />
          </View>
        </View>
        <View
          style={{
            flex: 1,
          }}
        >
          {/* Inner view that is responsible to get _ON TOP_ of the map */}
          <View
            style={[{
              position: 'absolute',
              overflow: 'hidden',
              backgroundColor: 'white',
              flex: 1,
              // borderColor: 'red',
              // borderWidth: 1,
            }, direction === 'column' ? {
              top: -mapRadius,
              bottom: 0,
              width: '100%',
              borderTopLeftRadius: mapRadius,
              borderTopRightRadius: mapRadius,
            } : {
              left: -mapRadius,
              right: 0,
              height: '100%',
              borderTopLeftRadius: mapRadius,
              borderBottomLeftRadius: mapRadius,
            }]}
          >
            {items.length > 0 ? (
              <SuperFlatFading
                Component={FlatGrid}
                style={{
                  backgroundColor: 'white',
                  flex: 1,
                  padding: 0,
                  margin: 0,
                }}
                itemContainerStyle={{
                  padding: 0,
                  margin: 0,
                }}
                key={items.length} // trigger redraw when the number of items change: to update fading
                itemDimension={300}
                data={items}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    accessibilityLabel={item.data.name}
                    accessibilityRole="link"
                    href={`/ai-agent/${item.data.uuid}`}
                    style={{ padding: 0, margin: 0 }}
                    key={item.data.uuid}
                    onPress={() => (
                      history.push(`/ai-agent/${item.data.uuid}`)
                    )}
                  >
                    <AppBadge
                      data={item.data}
                      selected={selectedItem === item.data.uuid}
                    />
                  </TouchableOpacity>
                )}
              />
            ) : (
              <View
                style={{
                  alignItems: 'center',
                  backgroundColor: 'white',
                  flex: 1,
                }}
              >
                {initialLoad ? (
                  <View
                    style={{
                      flex: 1,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <ActivityIndicator size="large" color={styles.primaryColor} />
                  </View>
                ) : (
                  <Text
                    style={{
                      width: '80%',
                      paddingVertical: 40,
                      flex: 1,
                      textAlign: 'center',
                    }}
                  >
                    {translate('home_not_found')}
                  </Text>
                )}
                <Text
                  style={{
                    width: '80%',
                    textAlign: 'center',
                  }}
                >
                  {translate('home_be_first')}
                </Text>
                <Button
                  title={translate('publisher_apps_token')}
                  containerStyle={{
                    width: '80%',
                    maxWidth: 400,
                    paddingTop: 20,
                  }}
                  buttonStyle={styles.buttonfsf.primary}
                  disabledStyle={styles.buttonfsf.primaryDisabled}
                  titleStyle={styles.buttonfsf.primaryTitle}
                  disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
                  onPress={() => {
                    if (user && user.username) {
                      history.push('/token');
                    } else {
                      history.push('/signin/token');
                    }
                  }}
                />
                <Button
                  title={translate('publisher_apps_add')}
                  disabled
                  containerStyle={{
                    width: '80%',
                    maxWidth: 400,
                    paddingTop: 20,
                    paddingBottom: Platform.OS === 'ios' ? 50 : 40,
                  }}
                  buttonStyle={styles.buttonfsf.primary}
                  disabledStyle={styles.buttonfsf.primaryDisabled}
                  titleStyle={styles.buttonfsf.primaryTitle}
                  disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
                  onPress={() => {
                    if (user && user.username) {
                      history.push('/addapp');
                    } else {
                      history.push('/signin/addapp');
                    }
                  }}
                />
              </View>
            )}
          </View>
        </View>
      </View>
    );
  }
}

Home.defaultProps = {
  user: null,
  userData: null,
  // position: null,
  search: null,
  searchInProgress: false,
  searchNotFound: false,
  searchName: '',
  searchPosition: null,
  // layoutOrientation: undefined,
};

Home.propTypes = {
  config: AORTypes.Config.isRequired,
  user: AORTypes.AWS.Cognito.User,
  userData: AORTypes.User,
  // position: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  search: PropTypes.string,
  searchInProgress: PropTypes.bool,
  searchNotFound: PropTypes.bool,
  searchName: PropTypes.string,
  // layoutOrientation: PropTypes.string,
  direction: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  client: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  getAnalyticsService: PropTypes.func.isRequired,
};

// 'withApollo' is used to set the prop 'client'
export default withApollo(Home);
